// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"18505753","134":"c4d4b875","179":"624f685a","204":"5e5a4260","223":"ce560c10","241":"8affc506","245":"a01d57c9","348":"d78a74f1","372":"a7a807f1","483":"9fcf56ff","489":"ea120047","584":"670371cb","754":"10f4c9fb","902":"d1969eda","963":"22c05e67","972":"87a3d027"}[chunkId] + ".chunk.js";
};